import { getServiceAsync } from '../../service';
import { runOwsRequestWithMonitor, Feature } from '../../shared';

export function deleteFolder(id: string): Promise<boolean> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'DeleteFolder',
            feature: Feature.FolderManagement,
            operation: () =>
                service.Operation.deleteContactFolderOperation({
                    folderId: service.Factory.folderId({ Id: id }),
                }),
            transformResponse: (response: boolean) => response,
        })
    );
}
